import React, { useRef } from 'react';
import { getAccessToken } from '../services/local_storage_service';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { REACT_ROUTES } from '../constants/react_routes';
import { SnackbarProvider } from 'notistack';
import { makeStyles, IconButton } from '@material-ui/core';
import { Clear } from '@material-ui/icons';

const useStyles = makeStyles({
    icon: {
        color: '#fff'
    }
});

const PublicRoute = ({ component: Component, ...rest }) => {
    const { icon } = useStyles();

    const notistackRef = useRef(null);
    const onClickDismiss = key => () => {
        notistackRef.current.closeSnackbar(key);
    }

    return (
        <Route {...rest} render={props => (
            getAccessToken()
                ?
                <Redirect to={REACT_ROUTES.SCHEDULER} />
                :
                <SnackbarProvider
                    ref={notistackRef}
                    maxSnack={3}
                    preventDuplicate
                    action={(key) => (
                        <IconButton onClick={onClickDismiss(key)}>
                            <Clear className={icon} />
                        </IconButton>
                    )}
                >
                    <Component {...props} />
                </SnackbarProvider>
        )} />
    )
}

PublicRoute.propTypes = {
    component: PropTypes.elementType
};

export default PublicRoute;
